<template>
    <div class="card mb-4">
        <div class="card-body d-flex flex-column flex-fill">
            <!--
            <div class="d-flex flex-row" v-show="(tx.short_tx_id !== null)">
                {{ `txid: ${ tx.short_tx_id }` }}
            </div>
            -->

            <div class="d-flex flex-row flex-fill">
                <!-- 送受信アイコン -->
                <div class="d-flex flex-row">
                    <div v-if="(isTransferTx(tx))" class="direction-icon">
                        <img src="./images/arrow-out.png" alt="Out" width="38" height="38" />
                    </div>
                    <div v-else class="direction-icon">
                        <img src="./images/arrow-in.png" alt="In" width="38" height="38" />
                    </div>
                </div>

                <div class="d-flex flex-column flex-fill ml-3 align-content-stretch">
                    <!-- 基本情報 -->
                    <div class="d-flex flex-row flex-fill flex-wrap">
                        <!-- 日付 -->
                        <div class="d-flex flex-column flex-fill width-auto">
                            <div class="font-weight-bold">
                                {{ $t('token.detail.date-label') }}
                            </div>
                            <div>
                                {{ tx.created_at | moment('YYYY/MM/DD HH:mm:ss') }} (SGT)
                            </div>
                        </div>

                        <!-- 数量 -->
                        <div class="d-flex flex-column flex-fill width-auto">
                            <div class="font-weight-bold">
                                {{ $t('token.detail.volume-label') }}
                            </div>
                            <div>
                                {{ tx.amount | round }}
                            </div>
                        </div>

                        <!-- タイプ -->
                        <div class="d-flex flex-column flex-fill width-auto">
                            <div class="font-weight-bold">
                                {{ $t('token.detail.type-label') }}
                            </div>
                            <div>
                                {{ `${ getTypeText(this.tx) }` }}
                            </div>
                        </div>

                        <!-- ステータス -->
                        <div class="d-flex flex-column flex-fill width-75">
                            <div class="font-weight-bold">
                                {{ $t('token.detail.status-label') }}
                            </div>
                            <div>
                                <img v-if="(isStatusNOOP())"       src="./images/icon-pending.png"    alt="NOOP"       width="17" height="17" />
                                <img v-if="(isStatusProcessing())" src="./images/icon-processing.png" alt="Processing" width="17" height="17" />
                                <img v-if="(isStatusFailure())"    src="./images/icon-failed.png"     alt="Failed"     width="17" height="17" />
                                <img v-if="(isStatusSuccess())"    src="./images/icon-completed.png"  alt="Completed"  width="17" height="17" />
                                <img v-if="(isStatusRejected())"   src="./images/icon-rejected.png"   alt="Rejected"   width="17" height="17" />
                                <img v-if="(isStatusCancelled())"  src="./images/icon-failed.png"     alt="Cancelled"  width="17" height="17" />
                                <img v-if="(isStatusPending())"    src="./images/icon-pending.png"    alt="Pending"    width="17" height="17" />
                                {{ $t(`token.statuses.${ tx.status }`) }}
                            </div>
                        </div>
                    </div>

                    <!-- キャンセルボタン; ステータスが PENDING のときのみ表示 -->
                    <div v-if="(isStatusPending())" class="d-flex flex-row mt-3">
                        <button type="button" v-on:click="onClickCancelButtonHandler()" class="btn btn-outline-primary cancel-btn rounded">
                            {{ $t('token.detail.cancel-button-label') }}
                        </button>
                    </div>
                            
                    <!-- 追加情報 -->
                    <div class="d-flex flex-column flex-fill mt-3 dashed-border-top">
                        <!-- 送付先アドレス -->
                        <div v-if="(((tx.type === 'TYPE_NORMAL') || (tx.type === 'TYPE_ORDER') || (tx.type === 'TYPE_MEMBERSHIP_FEE')) && (isTransferTx(tx)))" class="d-flex flex-column flex-fill width100 mt-3">
                            <div class="font-weight-bold">
                                {{ $t('token.detail.transfer-to-label') }}
                            </div>
                            <div class="text-break">
                                {{ `${ getToAddress(this.tx) }` }}
                            </div>
                        </div>

                        <!-- 送信元アドレス -->
                        <div v-if="(((tx.type === 'TYPE_NORMAL') || (tx.type === 'TYPE_OTHER')) && (! isTransferTx(tx)))" class="d-flex flex-column flex-fill width100 mt-3">
                            <div class="font-weight-bold">
                                {{ $t('token.detail.transfer-from-label') }}
                            </div>
                            <div class="text-break">
                                {{ `${ getFromAddress(this.tx) }` }}
                            </div>
                        </div>

                        <!-- 詳細情報 -->
                        <div v-if="((tx.remarks !== null) && (tx.remarks !== undefined))" class="d-flex flex-column flex-fill width100 mt-3">
                            <div class="font-weight-bold">
                                {{ $t('token.detail.detail-label') }}
                            </div>
                            <div>
                                {{ tx.remarks }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import moment from "moment";
    export default {
        name: 'TokenTransactionItem',

        props: {
            tx  : new Object(),
            self: '',
        },

        methods: {
            isTransferTx() {
                return (String(this.tx.to_address).toLowerCase() !== String(this.self).toLowerCase());
            },

            isStatusNOOP() {
                return (this.tx.status === 'STATUS_NOOP');
            },

            isStatusProcessing() {
                return (this.tx.status === 'STATUS_PROCESSING');
            },

            isStatusFailure() {
                return (this.tx.status === 'STATUS_FAILURE');
            },

            isStatusSuccess() {
                return (this.tx.status === 'STATUS_SUCCESS');
            },

            isStatusRejected() {
                return (this.tx.status === 'STATUS_REJECTED');
            },

            isStatusCancelled() {
                return (this.tx.status === 'STATUS_CANCELLED');
            },

            isStatusPending() {
                return (this.tx.status === 'STATUS_PENDING');
            },

            onClickCancelButtonHandler() {
                this.$emit('onClickCancelButton', this.tx.id);
            },

            getFromAddress(tx) {
                switch (tx.type) {
                    case 'TYPE_NORMAL' /** = '2' */:
                        return String(tx.from_address).toLowerCase();
                    case 'TYPE_OTHER' /** = '6' */:
                        return 'EduTek Wallet';
                    default:
                        return String(tx.from_address).toLowerCase();
                }
            },

            getToAddress(tx) {
                switch (tx.type) {
                    case 'TYPE_NORMAL' /** = '2' */:
                        return String(tx.to_address).toLowerCase();
                    case 'TYPE_MEMBERSHIP_FEE' /** = '4' */:
                    case 'TYPE_ORDER' /** = '5' */:
                        return 'EduTek Wallet';
                    default:
                        return String(tx.to_address).toLowerCase();
                }
            },

            getTypeText(tx) {
                switch (tx.type) {
                    case 'TYPE_FORTHING' /** = '0' */:
                        return this.$i18n.t('token.types.TYPE_FORTHING');
                    case 'TYPE_BONUS' /** = '1' */:
                        return this.$i18n.t('token.types.TYPE_BONUS');
                    case 'TYPE_NORMAL' /** = '2' */:
                        if (this.isTransferTx()) {
                            return this.$i18n.t('token.detail.transfer');
                        } else {
                            return this.$i18n.t('token.detail.deposit');
                        }
                    case 'TYPE_EX_BONUS' /** = '3' */:
                        return this.$i18n.t('token.types.TYPE_EX_BONUS');
                    case 'TYPE_MEMBERSHIP_FEE' /** = '4' */:
                        return this.$i18n.t('token.types.TYPE_MEMBERSHIP_FEE');
                    case 'TYPE_ORDER' /** = '5' */:
                        return this.$i18n.t('token.types.TYPE_ORDER');
                    case 'TYPE_OTHER' /** = '6' */:
                        return this.$i18n.t('token.types.TYPE_OTHER');
                    case 'TYPE_EX_BONUS_PLAN' /** = '7' */:
                        return this.$i18n.t('token.types.TYPE_EX_BONUS');
                    case 'TYPE_CAMPAIGN' /** = '8' */:
                        return this.$i18n.t('token.types.TYPE_CAMPAIGN');
                    case 'TYPE_AGGREGATED_USER' /** = '100' */:
                        return this.$i18n.t('token.types.TYPE_AGGREGATED_USER');
                    case 'TYPE_SUPPLEMENTED_AGGREGATE' /** = '102' */:
                        return this.$i18n.t('token.types.TYPE_SUPPLEMENTED_AGGREGATE');
                    default:
                        return '';
                }
            },
            
        },

        computed: {
        }
    }
</script>

<style scoped>
    .dashed-border-top {
        border-top: 1px dashed #dee2e6;
    }
    .direction-icon {
        width: 38px;
    }
    .width-75 {
        width: 75px;
    }
    .width-auto {
        width: auto;
    }
    .cancel-btn {
        padding: 2px 12px;
        font-size: 10px;
        width: 140px;
    }
    .btn-primary:hover,
    .btn-outline-primary:hover {
        color: #fff !important;
    }

    @media screen and (max-width: 500px) {
        .width-auto,
        .width-75 {
            width: 100%;
        }
        .width-auto + .width-auto,
        .width-auto + .width-75 {
            margin-top: .5em;
        }
    }
</style>